import { render, staticRenderFns } from "./QuestionSolve.vue?vue&type=template&id=06125550&scoped=true&"
import script from "./QuestionSolve.vue?vue&type=script&lang=js&"
export * from "./QuestionSolve.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSolve.vue?vue&type=style&index=0&id=06125550&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06125550",
  null
  
)

export default component.exports